import type { MaybeRefOrGetter } from 'vue'

import { toValue } from 'vue'

type JsonLdSource = MaybeRefOrGetter<object | undefined>

/**
 * 注入页面 JSON-LD 结构化数据。
 * @param sources - 结构化数据来源，返回空值时跳过对应脚本
 */
export function useJsonLd(...sources: JsonLdSource[]) {
  useHead(() => ({
    script: (sources.map((source) => toValue(source)).filter(Boolean) as object[]).map(
      (schema) => ({
        type: 'application/ld+json',
        innerHTML: JSON.stringify(schema),
      })
    ),
  }))
}
